import { getHeaders, checkStatus } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

export const addApplyWFH = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/WFH/Apply`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

//Get the details of the WFH for user.
export const getWFHDetails = async (params) =>{
  try{
    const response = await axiosInstance.post(`${baseURL}/WFH/WFHDetails`,params,
     {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response); 
    return response.data;
  }catch (error){
    return Promise.reject(error);
  }
}

// For Update WFH Status .
export const postWFHStatusData = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/StatusWFH`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For Withdrawal WFH .
export const withdrawalWFHData = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/WFH/Withdraw`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Update the status of WFH .
 export const approveWfhStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/WFH/Approve`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Update the status of WFH .

 export const rejectWFHStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/WFH/Reject`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Update the status of WFH .

 export async function withdrwalWfhStatus(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/WFH/Withdrawn`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For GEt Leave dashboard count.
 export const WFHDashboardBalenceCount = async (params) =>{
  try{
    const response = await axiosInstance.get(`${baseURL}/WFH/Balance`,
     {
      params: {
        EmpId: params.EmpId,
        TypeId: params.TypeId,
    },
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response); 
    return response.data;
  }catch (error){
    return Promise.reject(error);
  }
}

// For GET WFH Ledger  Details.
export async function getWFHLedgerDetails(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/WFH/WFHLedger`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

  // For ADD the Emp Leaves.
  export const PostWFHAdjustment = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/WFH/Adjustment`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  // Get Organisation Setting wfh 

export const getOrganizationWfh = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Leave/WFHType/GetAllWFH`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

//Delete wfh  Organisation Setting 

export const deleteOrganizationWfh = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Leave/WFHType/Delete`,
      {
        headers: await getHeaders(),
        data: params  
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

//Organization Setting Wfh  Edit/Add 

 export const addOrganizationWfh = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Leave/WFHType/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };